module.exports = __webpack_public_path__ + "img/hero_about.264a9347.jpg";